import { render, staticRenderFns } from "./EditAssetPoolDistribution.vue?vue&type=template&id=ae001364&scoped=true&"
import script from "./EditAssetPoolDistribution.vue?vue&type=script&lang=js&"
export * from "./EditAssetPoolDistribution.vue?vue&type=script&lang=js&"
import style0 from "./EditAssetPoolDistribution.vue?vue&type=style&index=0&id=ae001364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae001364",
  null
  
)

export default component.exports